'use es6';

import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import { getEntries } from 'conversations-async-data/indexed-async-data/operators/getters';
import { Map as ImmutableMap } from 'immutable';
import { createSelector } from '@reduxjs/toolkit';
import set from 'transmute/set';
import { getResolvedAttachments } from './getResolvedAttachments';
export const getSuccessfulFileAttachments = createSelector([getResolvedAttachments], resolvedAttachmentAsyncData => {
  if (!resolvedAttachmentAsyncData || !getEntries(resolvedAttachmentAsyncData).size) {
    return ImmutableMap();
  }
  return getEntries(resolvedAttachmentAsyncData).reduce((successfulAttachments, entry, attachmentId) => {
    if (!entry || !attachmentId || !isSucceeded(entry)) {
      return successfulAttachments;
    }
    return set(String(attachmentId), getData(entry), successfulAttachments);
  }, ImmutableMap());
});